import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PipelineService from "../../../Services/Pipeline.service";
import OpportunityAssigneeLookupModal from "./OpportunityAssigneeLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => PipelineService.getApplicableAssignees(Object.assign(Object.assign({}, options), { pipelineId: options.pipelineId, query: search })).then(({ data }) => data),
    label: "fullName",
    value: "personId",
};
export const OpportunityAssigneeSearch = makeSearch(makeSearchArgs);
export const OpportunityAssigneeMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: OpportunityAssigneeLookupModal }));
